import { Swiper } from 'swiper';
import { Navigation, Keyboard } from 'swiper/modules';
import GLightbox from 'glightbox';
import 'glightbox/dist/css/glightbox.css';

import 'swiper/scss'; // Core
import 'swiper/scss/a11y';
import 'swiper/scss/navigation';
import 'swiper/scss/keyboard';

import './style.scss';
/* eslint-disable consistent-return */
/* eslint-disable no-undef */
/* eslint-disable no-new */
( function () {
	/**
	 * initializeBlock
	 *
	 * Adds custom JavaScript to the block HTML.
	 *
	 * @date    15/4/19
	 * @since   1.0.0
	 *
	 * @param object $block The block jQuery element.
	 * @param object attributes The block attributes (only available when editing).
	 * @return  void
	 */

	const blockType = 'slider';
	const blockClass = `block--${ blockType }`;

	function initBlock( blockClass ) {
		const lightbox = GLightbox( {
			selector: '.glightbox',
			openEffect: 'fade',
			closeEffect: 'fade',
			loop: true,
            moreLength: 0,
		} );

		lightbox.on( 'slide_after_load', ( event ) => {
			const slide = event.slideNode;

			const image = slide.querySelector( 'img' );
			console.log( image );

			const width = image.width;
			console.log( width );
			const height = image.height;
			console.log( height );

			if ( width > height ) {
				console.log( 'full width' );
				image.classList.add( 'full-width' );
			} else {
				console.log( 'full height' );
				image.classList.add( 'full-height' );
			}
		} );

		if ( blockClass.querySelectorAll( '.swiper-slide' ).length > 1 ) {
			// eslint-disable-next-line no-undef
			new Swiper( blockClass.querySelector( '.swiper' ), {
				modules: [ Navigation, Keyboard ],
				slidesPerView: 1,
				spaceBetween: 1,
				speed: 700,
				keyboard: true,
				loop: true,
				keyboard: {
					enabled: true,
					onlyInViewport: false,
				},
				navigation: {
					nextEl: blockClass.querySelector( '.swiper-button-next' ),
					prevEl: blockClass.querySelector( '.swiper-button-prev' ),
				},
				on: {
					slideChange() {
						const texts = document.querySelectorAll(
							'.slider__texts-container__text-wrapper'
						);

						texts.forEach( ( text ) => {
							const textId = text.getAttribute( 'data-text' );

							if ( this.realIndex == textId ) {
								text.style.display = 'inline';
							} else {
								text.style.display = 'none';
							}
						} );
					},
				},
			} );
		}
	}

	/**
	 * Initialize each block on page load (front end).
	 */
	document.addEventListener( 'DOMContentLoaded', () => {
		console.log( blockClass );
		document.querySelectorAll( `.${ blockClass }` ).forEach( ( block ) => {
			console.log( block );
			initBlock( block );
		} );
	} );

	/**
	 * Initialize dynamic block preview (editor).
	 * @param $block
	 */
	const initializeBlock = function ( $block ) {
		const block = $block[ 0 ].querySelector( `.${ blockClass }` );

		if ( block ) {
			initBlock( block );
		}
	};

	if ( window.acf ) {
		window.acf.addAction(
			`render_block_preview/type=${ blockType }`,
			initializeBlock
		);
	}
} )();
